import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import './_styles_/RequestRateLimits.css';
import {
    requestRateLimitPropertiesType,
    requestRateLimitsType,
} from '../../types';
import RequestRateLimitsTable from './RequestRateLimitsTable';
import RequestRateLimitCreate from './RequestRateLimitCreate';
import ResetFieldButton from '../buttons/ResetFieldButton';

RequestRateLimits.propTypes = {
    requestRateLimits: requestRateLimitsType.isRequired,
    requestRateLimitProps: requestRateLimitPropertiesType.isRequired,
    onRequestRateLimitCreate: PropTypes.func.isRequired,
    onRequestRateLimitDelete: PropTypes.func.isRequired,
    onRequestRateLimitChange: PropTypes.func.isRequired,
    onReset: PropTypes.func.isRequired,
    isChanged: PropTypes.bool.isRequired,
    backendChanged: PropTypes.bool.isRequired,
    doReset: PropTypes.bool.isRequired,
};

function RequestRateLimits(props) {
    const {
        requestRateLimits,
        requestRateLimitProps,
        onRequestRateLimitCreate,
        onRequestRateLimitDelete,
        onRequestRateLimitChange,
        onReset,
        isChanged,
        backendChanged,
        doReset,
    } = props;
    const { t } = useTranslation();
    return (
        <div className={`settings-detail-tab--request-rate-limits field${isChanged ? ' modified' : ''}`}>
            <div className="request-rate-limits-field">
                <span className="field--key">{t('settings.request-rates-and-limits.request-rate-limits.title')}</span>
                <RequestRateLimitCreate
                    requestRateLimits={requestRateLimits}
                    requestRateLimitProps={requestRateLimitProps}
                    onRequestRateLimitCreate={onRequestRateLimitCreate}
                />
                <RequestRateLimitsTable
                    requestRateLimits={requestRateLimits}
                    onRequestRateLimitDelete={onRequestRateLimitDelete}
                    onRequestRateLimitChange={onRequestRateLimitChange}
                    backendChanged={backendChanged}
                    doReset={doReset}
                />
            </div>
            {isChanged && onReset && <ResetFieldButton onReset={onReset} />}
        </div>
    );
}

export default RequestRateLimits;
